(() => {
  const money = (el) => {
    try {
      return new Intl.NumberFormat(el.dataset.locale, { style: 'currency', currency: el.dataset.currency });
    } catch (e) {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: el.dataset.currency || 'GBP' });
    }
  };

  if (!customElements.get('cp-kits')) {
    customElements.define(
      'cp-kits',
      class CpKits extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-cpk-variants]').textContent);
          this.currentId = Number(this.dataset.variant);
          this.bars = Array.from(this.querySelectorAll('.cpk__bar'));
          this.fmt = money(this);

          this.bars.forEach((bar) => {
            const radio = bar.querySelector('.cpk__radio');
            radio.addEventListener('change', () => this.select(bar));
            bar.addEventListener('click', (event) => {
              if (event.target.closest('select, button, input[type=number], input[type=checkbox]') && bar !== this.selected) {
                radio.checked = true;
                this.select(bar);
              }
            });
            const bindUnit = (select) => {
              select.addEventListener('change', () => {
                select.dataset.touched = 'true';
                this.update(bar);
                if (select === bar.querySelector('[data-cpk-unit]')) this.syncMain(Number(select.value));
              });
            };
            bar.querySelectorAll('[data-cpk-unit]').forEach(bindUnit);
            const upsell = bar.querySelector('[data-cpk-upsell]');
            if (upsell) {
              const upVariants = JSON.parse(upsell.querySelector('[data-cpk-up-variants]').textContent);
              const upSelect = upsell.querySelector('select[data-cpk-up-variant]');
              const check = upsell.querySelector('[data-cpk-up-check]');
              check.addEventListener('change', () => upsell.classList.toggle('is-checked', check.checked));
              if (upSelect) {
                upSelect.addEventListener('change', () => {
                  const v = upVariants.find((x) => x.id === Number(upSelect.value));
                  if (!v) return;
                  const qty = Number(upsell.dataset.qty) || 1;
                  const was = v.p * qty;
                  upsell.querySelector('[data-cpk-up-price]').textContent = this.fmt.format((was - Math.round((was * (Number(upsell.dataset.off) || 0)) / 100)) / 100);
                  upsell.querySelector('[data-cpk-up-was]').textContent = this.fmt.format(was / 100);
                });
              }
            }
            const step = bar.querySelector('[data-cpk-step]');
            if (step) {
              const syncRows = (n) => {
                const rows = bar.querySelectorAll('.cpk__unit');
                if (!rows.length) return;
                for (let i = rows.length; i < n; i++) {
                  const last = bar.querySelectorAll('.cpk__unit')[i - 1];
                  const row = last.cloneNode(true);
                  const select = row.querySelector('[data-cpk-unit]');
                  select.value = last.querySelector('[data-cpk-unit]').value;
                  delete select.dataset.touched;
                  bindUnit(select);
                  last.after(row);
                }
                Array.from(bar.querySelectorAll('.cpk__unit'))
                  .slice(n)
                  .forEach((row) => row.remove());
              };
              const set = (n) => {
                step.value = Math.min(20, Math.max(1, n || 1));
                syncRows(Number(step.value));
                this.update(bar);
              };
              bar.querySelector('[data-cpk-minus]').addEventListener('click', (e) => {
                e.preventDefault();
                set(Number(step.value) - 1);
              });
              bar.querySelector('[data-cpk-plus]').addEventListener('click', (e) => {
                e.preventDefault();
                set(Number(step.value) + 1);
              });
              step.addEventListener('change', () => set(Number(step.value)));
            }
          });

          if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              const variant = event.data && event.data.variant;
              if (variant) this.setCurrent(variant.id);
            });
          }
          const form = cpProductForm(this);
          const idInput = form && form.querySelector('[name=id]');
          if (idInput) idInput.addEventListener('change', () => this.setCurrent(Number(idInput.value)));

          this.bars.forEach((bar) => this.update(bar));
        }

        disconnectedCallback() {
          if (this.unsubscribe) this.unsubscribe();
        }

        get selected() {
          return this.bars.find((bar) => bar.classList.contains('is-selected'));
        }

        variant(id) {
          return this.variants.find((v) => v.id === Number(id));
        }

        select(bar) {
          if (bar === this.selected) return;
          this.bars.forEach((b) => b.classList.toggle('is-selected', b === bar));
          bar.classList.remove('cpk-pop');
          void bar.offsetWidth;
          bar.classList.add('cpk-pop');
          bar.addEventListener('animationend', () => bar.classList.remove('cpk-pop'), { once: true });
        }

        // Picking a colour in a kit row does what clicking the colour circle does: switch the product to that variant.
        syncMain(id) {
          const v = this.variant(id);
          if (!v || !v.o || id === this.currentId) return;
          v.o.forEach((value, i) => {
            const group = document.querySelector(`#MainContent .swatch--gl[data-option-index="${i}"]`);
            const option = group && Array.from(group.querySelectorAll('li.select-option')).find((li) => li.dataset.value === value);
            const input = option ? option.querySelector('input') : Array.from(document.querySelectorAll('variant-selects input[type=radio]')).find((el) => el.value === value && el.closest('fieldset') === document.querySelectorAll('variant-selects fieldset')[i]);
            if (input && !input.checked) (option ? option.querySelector('label') || input : input).click();
          });
          const gallery = document.querySelector('#MainContent media-gallery');
          if (gallery) window.scrollTo({ top: gallery.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
        }

        setCurrent(id) {
          if (!id || id === this.currentId || !this.variant(id)) return;
          this.currentId = id;
          this.bars.forEach((bar) => {
            bar.querySelectorAll('[data-cpk-unit]').forEach((select, i) => {
              if (i === 0 || !select.dataset.touched) select.value = String(id);
            });
            this.update(bar);
          });
        }

        unitIds(bar) {
          const selects = Array.from(bar.querySelectorAll('[data-cpk-unit]'), (s) => Number(s.value));
          const step = bar.querySelector('[data-cpk-step]');
          if (step && !selects.length) return Array(Number(step.value) || 1).fill(this.currentId);
          if (selects.length) return selects;
          return Array(Number(bar.dataset.qty) || 1).fill(this.currentId);
        }

        lines() {
          const bar = this.selected;
          if (!bar) return null;
          const lines = [];
          this.unitIds(bar).forEach((id) => {
            const line = lines.find((l) => l.id === id);
            if (line) line.quantity += 1;
            else lines.push({ id, quantity: 1 });
          });
          const upsell = bar.querySelector('[data-cpk-upsell]');
          if (upsell && upsell.querySelector('[data-cpk-up-check]').checked) {
            lines.push({
              id: Number(upsell.querySelector('[data-cpk-up-variant]').value),
              quantity: Number(upsell.dataset.qty) || 1,
            });
          }
          return lines;
        }

        update(bar) {
          const ids = this.unitIds(bar);
          const off = Number(bar.dataset.off) || 0;
          let sub = 0;
          let full = 0;
          ids.forEach((id) => {
            const v = this.variant(id) || this.variant(this.currentId);
            sub += v.p;
            full += off ? v.p : Math.max(v.c, v.p);
          });
          const price = sub - Math.round((sub * off) / 100);

          const priceEl = bar.querySelector('[data-cpk-price]');
          const fullEl = bar.querySelector('[data-cpk-full]');
          const text = this.fmt.format(price / 100);
          if (priceEl.textContent !== text) {
            priceEl.classList.add('is-updating');
            requestAnimationFrame(() => {
              priceEl.textContent = text;
              priceEl.classList.remove('is-updating');
            });
          }
          fullEl.textContent = this.fmt.format(full / 100);
          fullEl.hidden = full <= price;

          const swap = (img, id) => {
            const v = this.variant(id);
            if (img && v && v.img && img.getAttribute('src') !== v.img) {
              img.removeAttribute('srcset');
              img.setAttribute('src', v.img);
            }
          };
          bar.querySelectorAll('.cpk__thumb').forEach((img, i) => swap(img, ids[Math.min(i, ids.length - 1)]));
          bar.querySelectorAll('.cpk__unit').forEach((unit) => {
            const select = unit.querySelector('[data-cpk-unit]');
            if (select) swap(unit.querySelector('.cpk__unit-img'), select.value);
          });
        }
      }
    );
  }

  if (!customElements.get('cp-bundle')) {
    customElements.define(
      'cp-bundle',
      class CpBundle extends HTMLElement {
        connectedCallback() {
          this.fmt = money(this);
          this.pct = Number(this.dataset.pct) || 0;
          this.querySelectorAll('.cpb__item').forEach((item) => {
            const variants = JSON.parse(item.querySelector('[data-cpb-variants]').textContent);
            const select = item.querySelector('select[data-cpb-variant]');
            const check = item.querySelector('[data-cpb-check]');
            check.addEventListener('change', () => item.classList.toggle('is-checked', check.checked));
            if (!select) return;
            select.addEventListener('change', () => {
              const v = variants.find((x) => x.id === Number(select.value));
              if (!v) return;
              item.querySelector('[data-cpb-sale]').textContent = this.fmt.format((v.p - Math.round((v.p * this.pct) / 100)) / 100);
              item.querySelector('[data-cpb-was]').textContent = this.fmt.format(v.p / 100);
              const img = item.querySelector('.cpb__img');
              if (img && v.img) {
                img.removeAttribute('srcset');
                img.setAttribute('src', v.img);
              }
            });
          });
        }

        lines() {
          return Array.from(this.querySelectorAll('.cpb__item'))
            .filter((item) => item.querySelector('[data-cpb-check]').checked)
            .map((item) => ({ id: Number(item.querySelector('[data-cpb-variant]').value), quantity: 1 }));
        }
      }
    );
  }

  if (!customElements.get('cp-sticky-atc')) {
    customElements.define(
      'cp-sticky-atc',
      class CpStickyAtc extends HTMLElement {
        connectedCallback() {
          const form = cpProductForm(this);
          if (!form) return;
          this.form = form;
          this.mainButton = form.querySelector('[type=submit]');
          this.atc = this.querySelector('[data-cps-atc]');
          this.label = this.querySelector('[data-cps-variant]');
          if (this.parentElement !== document.body) document.body.appendChild(this);

          this.atc.addEventListener('click', () => {
            if (this.mainButton && this.mainButton.disabled) return;
            if (form.requestSubmit) form.requestSubmit(this.mainButton || undefined);
            else this.mainButton && this.mainButton.click();
          });
          const change = this.querySelector('[data-cps-change]');
          if (change) {
            change.addEventListener('click', () => {
              const target = document.querySelector('variant-selects, .product-form__input, cp-kits') || form;
              target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
          }

          if (this.mainButton && 'IntersectionObserver' in window) {
            new IntersectionObserver(([entry]) => {
              const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle('is-visible', past);
              this.setAttribute('aria-hidden', String(!past));
              this.querySelectorAll('button').forEach((b) => (b.tabIndex = past ? 0 : -1));
            }).observe(this.mainButton);
          }

          if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
            subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              const variant = event.data && event.data.variant;
              if (!variant) return;
              if (this.label && this.querySelector('[data-cps-change]')) this.label.textContent = variant.title;
              this.atc.disabled = !variant.available;
              this.atc.textContent = variant.available ? 'Add to Cart' : 'Sold out';
            });
          }
        }
      }
    );
  }

  function cpProductForm(el) {
    const root = el.closest('product-info') || el.closest('section') || document;
    const productForm = root.querySelector('product-form');
    return productForm && productForm.querySelector('form');
  }

  function cpAttach(productForm) {
    if (productForm.dataset.cpAttached) return;
    productForm.dataset.cpAttached = 'true';
    const form = productForm.querySelector('form');
    if (!form) return;
    const root = productForm.closest('product-info') || productForm.closest('section') || document;
    let injected = [];

    productForm.addEventListener(
      'submit',
      (event) => {
        if (event.target !== form) return;
        injected.forEach((el) => el.remove());
        injected = [];

        const kits = root.querySelector('cp-kits');
        const bundle = root.querySelector('cp-bundle');
        const idInput = form.querySelector('[name=id]');
        const qtyInput =
          document.querySelector(`[name=quantity][form="${form.id}"]`) || form.querySelector('[name=quantity]');

        const main = (kits && kits.lines && kits.lines()) || [
          { id: Number(idInput && idInput.value), quantity: Number(qtyInput && qtyInput.value) || 1 },
        ];
        const extras = (bundle && bundle.lines && bundle.lines()) || [];
        const inject = (name, value) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          form.appendChild(input);
          injected.push(input);
        };

        if (main.length === 1 && !extras.length) {
          if (idInput) idInput.value = main[0].id;
          if (qtyInput) qtyInput.value = main[0].quantity;
          else inject('quantity', main[0].quantity);
          return;
        }

        if (idInput) idInput.removeAttribute('name');
        if (qtyInput) qtyInput.removeAttribute('name');
        main.concat(extras).forEach((line, i) => {
          inject(`items[${i}][id]`, line.id);
          inject(`items[${i}][quantity]`, line.quantity);
        });
        setTimeout(() => {
          if (idInput) idInput.setAttribute('name', 'id');
          if (qtyInput) qtyInput.setAttribute('name', 'quantity');
          injected.forEach((el) => el.remove());
          injected = [];
        });
      },
      true
    );
  }

  const init = () => document.querySelectorAll('product-form').forEach(cpAttach);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
